import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Text, Separator, ShapedIcon } from 'components/common';
import { getCourseTitle, getCourseIntroductions } from 'store/course/selectors';
import Contents from 'components/contents/Contents';
import { localize } from 'core/localization';
import { getAlternativeLogo } from 'store/settings/selectors';
import {
  Container,
  CourseInfoContainer,
  CourseInfoWrapper,
  IntroductionTitleContainer,
  IntroductionIcon,
  IntroductionTitle,
  ContentsContainer,
  LogoWrapper,
  CourseLogo
} from './CourseInformation.styled';

export class CourseInformation extends Component {
  render() {
    let { title, introductions, alternativeLogoUrl } = this.props;
    return (
      <Container>
        <CourseInfoContainer>
          <CourseInfoWrapper>
            <LogoWrapper>
              <CourseLogo logoUrl={alternativeLogoUrl} alt={localize('[logo easygenerator alt]')} />
            </LogoWrapper>
            <Text title={title} appearance="h1" inverted>
              {title}
            </Text>
            <Separator height={4} opacity={0.3} margin={56} color="coverBgOverlayTextColor" />
            {renderCourseIntroduction(introductions)}
          </CourseInfoWrapper>
        </CourseInfoContainer>
      </Container>
    );
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    introductions: PropTypes.array,
    alternativeLogoUrl: PropTypes.string
  };
}

function renderCourseIntroduction(introductions) {
  if (Array.isArray(introductions) && introductions.length !== 0) {
    return (
      <React.Fragment>
        <IntroductionTitleContainer>
          <IntroductionIcon
            size={18}
            fontSize={8}
            name="info"
            color="coverBgOverlayTextColor"
            shape={ShapedIcon.SHAPES.ROUND_OUTLINED}
          />
          <IntroductionTitle appearance="p" inverted>
            {localize('[course introduction]')}
          </IntroductionTitle>
        </IntroductionTitleContainer>
        <ContentsContainer>
          <Contents inverted items={introductions} />
        </ContentsContainer>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    alternativeLogoUrl: getAlternativeLogo(state),
    title: getCourseTitle(state),
    introductions: getCourseIntroductions(state)
  };
}
export default connect(mapStateToProps)(CourseInformation);
